import React, { useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search, Truck } from "lucide-react";
import { MapPin, Star, Truck as TruckIcon } from "lucide-react";
import { Carrier } from "@/api/broker/getCarriers";

type Props = {
  carriers: Carrier[];
  setSelectedCarrier: (carrier: Carrier) => void;
  selectedCarrier: Carrier | undefined;
};

export const CarriersList = ({
  carriers,
  setSelectedCarrier,
  selectedCarrier,
}: Props) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter carriers based on search term
  const filteredCarriers = carriers.filter((carrier) =>
    carrier.companyName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="lg:col-span-1">
      <Card className=" m-4">
        <CardHeader>
          <CardTitle>Carriers ({carriers?.length})</CardTitle>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <Input
              placeholder="Search carriers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
        </CardHeader>
        <CardContent className="p-0 h-[60vh] overflow-auto">
          <div className="space-y-2 overflow-y-auto px-6 pb-6">
            {filteredCarriers?.map((carrier) => (
              // Carrier Card
              <div
                key={carrier.id}
                onClick={() => setSelectedCarrier(carrier)}
                className={`p-4 rounded-lg border cursor-pointer transition-all ${
                  selectedCarrier?.id === carrier.id
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h3 className="font-medium">{carrier.companyName}</h3>
                    <p className="text-sm text-gray-600 flex items-center gap-1 mt-1">
                      <MapPin className="h-3 w-3" />
                      {carrier.address}
                    </p>
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
